module.exports = __webpack_public_path__ + "img/utilizator_premium_success.752b078c.png";